import { createContext, useContext, type ReactNode } from 'react';
import { systemClock, type Clock } from '@sl/core';

// D-020: nothing in the app reads the system time. Time comes from this Clock — `systemClock` in the real
// app, `fixedClock(...)` in tests and behind the `?demoNow=` QA switch (TEST_PLAN §1.5, §8.4).

const ClockContext = createContext<Clock>(systemClock);

export function ClockProvider({ clock, children }: { clock: Clock; children: ReactNode }) {
  return <ClockContext.Provider value={clock}>{children}</ClockContext.Provider>;
}

export function useClock(): Clock {
  return useContext(ClockContext);
}
